export default [
    {
        path: "/museumInfo",
        component: resolve => require(["@/views/museum/museumInfo"], resolve),
        meta: {
            title: "本馆简介"
        }
    },
    {
        path: "/dynamic",
        component: resolve => require(["@/views/museum/dynamic"], resolve),
        meta: {
            title: "馆内动态",
            keepAlive: true
        }
    },
    {
        path: "/dynamicDetail",
        component: resolve => require(["@/views/museum/dynamicDetail"], resolve),
        meta: {
            title: "馆内动态"
        }
    },
    {
        path: "/visitInfo",
        component: resolve => require(["@/views/museum/visitInfo"], resolve),
        meta: {
            title: "参观须知"
        }
    },
    {
        path: "/cultureShop",
        component: resolve => require(["@/views/museum/cultureShop"], resolve),
        meta: {
            title: "文创商店",
            keepAlive: true
        }
    },
    {
        path: "/goodsDetail",
        component: resolve => require(["@/views/museum/goodsDetail"], resolve),
        meta: {
            title: "文创商店"
        }
    }

]


// WEBPACK FOOTER //
// ./src/router/modules/museum.js